export function BoardSkeleton({ reduced }: { reduced: boolean }) {
  return (
    <div className="position-loading" data-reduced={reduced} aria-hidden="true">
      {Array.from({ length: 64 }, (_, index) => (
        <span
          key={index}
          className={(Math.floor(index / 8) + index) % 2 ? 'skeleton-dark' : 'skeleton-light'}
        />
      ))}
    </div>
  );
}
